var React = require('react');

function IconCaretDown16x16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33337 4.66663L8.00004 11.3333L14.6667 4.66663","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCaretDown16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconCaretDown16x16;

IconCaretDown16x16.default = IconCaretDown16x16;
